import { CoverImageOverlay } from "@circle-react-uikit/CoverImageInput/CoverImageOverlay";
import { Loader } from "@circle-react-uikit/Loader";
import type { MouseEvent } from "react";

import { t } from "@/i18n-js/instance";

export interface CoverImageWithButtonsProps {
  isLoading?: boolean;
  onChange?: (event: MouseEvent<HTMLButtonElement>) => void;
  onDelete?: (event: MouseEvent<HTMLButtonElement>) => void;
  url?: string;
}

export const CoverImageWithButtons = ({
  url,
  isLoading = false,
  onChange,
  onDelete,
}: CoverImageWithButtonsProps) => (
  <div className="md:px-6 md:pb-3 md:pt-5 lg:px-9">
    <div className="bg-primary aspect-16/5 relative h-full max-h-[20.625rem] md:mx-auto md:max-w-5xl md:overflow-hidden md:rounded-xl">
      {isLoading ? (
        <div className="absolute top-0 m-auto flex size-full">
          <Loader center />
        </div>
      ) : (
        <>
          {url ? (
            <img
              loading="lazy"
              className="size-full object-cover"
              src={url}
              alt=""
            />
          ) : (
            <div className="bg-tertiary size-full" />
          )}
          <CoverImageOverlay
            onDelete={onDelete}
            onChange={onChange}
            removeButtonText={t("remove_cover_image")}
            changeButtonText={
              url ? t("edit_cover_image") : t("add_cover_image")
            }
          />
        </>
      )}
    </div>
  </div>
);
